module.exports = __webpack_public_path__ + "img/btn_shitu_zheng.e39ecf3f.png";